import { PromotionsApi } from '../clients';
import { mapPayoutBatch } from '../mappers';

export const getPromotionPayouts = async (promotionId) => {
  const data = await PromotionsApi.getPromotionPayouts(promotionId);
  // Paginated envelope: { response: [...], total, page, limit }.
  const list = Array.isArray(data)
    ? data
    : data?.response ?? data?.payouts ?? data?.data ?? [];

  return list.map(mapPayoutBatch);
};
